"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _actions = require("../../../actions");
var _MessageContentWrapper = _interopRequireDefault(require("../../ui/MessageContentWrapper"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var MessageListing = function MessageListing(_ref) {
  var _ref$currentChat = _ref.currentChat,
    currentChat = _ref$currentChat === void 0 ? '' : _ref$currentChat,
    getMessagesHTTP = _ref.getMessagesHTTP;
  (0, _react.useEffect)(function () {
    if (currentChat && currentChat !== '1') {
      callJoinRoom();
    }
  }, [currentChat]);
  var callJoinRoom = function callJoinRoom() {
    getMessagesHTTP(currentChat);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageContentWrapper["default"], {
    errorAction: callJoinRoom
  });
};
MessageListing.propTypes = {
  currentChat: _propTypes.string
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    currentChat: state.currentChat
  };
};
var mapDispatchToProps = {
  getMessagesHTTP: _actions.getMessagesHTTP
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps, mapDispatchToProps)(MessageListing);